import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Keep custom font sizes separate from text colours. Without this extension,
// text-cell is treated as a colour and removes text-btntext on compact buttons.
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["micro", "chip", "meta", "body", "cell", "cell-title", "section", "sheet", "screen", "stat"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
